import React from 'react';
import DualActionDialog from '../DualActionDialog';

const DeleteHazardReviewDialog = (props) => {
  const { review, open, showDialog, errorMessage, isSaving } = props;

  const handleConfirmAction = async (event) => {
    event.preventDefault();
    const { onConfirmHazardReviewDelete, review } = props;
    const payload = {
      ...review
    };
    payload.isActive = false;
    onConfirmHazardReviewDelete(payload, payload.hazardId);
  };

  if (!review) {
    return;
  }

  return (
    <DualActionDialog
      open={open}
      title={`${'Delete'} ${review.description}`}
      description={`This hazard review will be deleted. Are you sure you want to delete ${review.description}?`}
      actionButtonText={'Delete'}
      cancelButtonText="Cancel"
      handleClose={() => showDialog(false, review.id)}
      handleSubmit={handleConfirmAction}
      showProgressBar={isSaving}
      errorMessage={errorMessage}
      isDanger={true}
    />
  );
};

export default DeleteHazardReviewDialog;
